import React from 'react';
import { usePageContentContext } from 'Views/Page/Contexts/PageContentContext';
import { MetaResourceRenderer } from 'Components/UI/Meta/MetaForm/Components/MetaResourceRenderer';
import { withGuidedHouseholdReviewLayout } from 'Components/UI/guidedHouseholdReview/layoutWrapper';
import { PM2JourneyInvestingTidbitsLayout } from './layout';
import { metaOverrideSet } from './metaOverrideSet';

const layout = withGuidedHouseholdReviewLayout(PM2JourneyInvestingTidbitsLayout, {
  condensed: true,
  fullWidth: true,
  hideTitle: true,
});

export const PM2JourneyInvestingTidbitsTemplate = ({ resource }) => {
  const { loadPageContentLink, setPageContentCollection, refreshPageContentCollection } = usePageContentContext();
  return (
    <MetaResourceRenderer
      metaOverrideSet={metaOverrideSet}
      layout={layout}
      onSubmit={setPageContentCollection}
      LayoutProps={{ navigateToLink: loadPageContentLink, refresh: refreshPageContentCollection }}
      resource={resource}
    />
  );
};
